import { CompanyWithCollaboratives } from "../../../types/company/company";
import { CompanyState } from "../../type/company-state";

interface Action {
  type: string;
  payload: {
    selectedCompanyWithCollaboratives: CompanyWithCollaboratives;
  };
}

export const setSelectedCompanyWithCollaborativesDispatch = (
  state: CompanyState,
  action: Action
) => {
  const { selectedCompanyWithCollaboratives } = action.payload;
  state.selectedCompanyWithCollaboratives = selectedCompanyWithCollaboratives;
};
